module.exports = __webpack_public_path__ + "img/MFT白皮书_49.30ee8d70.jpg";